export const ALL = 'ALL'
export const LAST_MONTH = 'LAST_MONTH'
export const LAST_YEAR = 'LAST_YEAR'
